import React from 'react'
import PropTypes from 'prop-types'
import * as bubbleUi from '@klarna/bubble-ui'
import { SelectorDirect } from '@klarna/bubble-ui'
import { useHelpContext } from '../../hooks'

OrientationItems.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      target: PropTypes.object.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired
    })
  ).isRequired
}

export default function OrientationItems ({ items }) {
  const { navigation } = useHelpContext()
  const options = items.map(item => ({
    label: item.title,
    description: item.description,
    icon: getIcon(item.icon),
    value: item.id
  }))

  function handleSelect (itemId) {
    const orientationItem = items.find(item => item.id === itemId)
    const { target } = orientationItem

    switch (target.contentType) {
      case 'UHQMArticle':
        navigation.push('article', { articleSlug: target.slug })
        break
      case 'UHQMTour':
        navigation.push('tour', { tourSlug: target.slug })
        break
    }
  }

  return (
    // eslint-disable-next-line react/jsx-no-bind
    <SelectorDirect key='selector' onSelect={handleSelect} options={options} />
  )
}

function getIcon (icon) {
  const Icon = bubbleUi[icon]
  return Icon ? <Icon /> : null
}
